import { useParams, Navigate } from 'react-router-dom';
import { articles } from '../dataStore';

const typeToFolder = {
  keyboard: 'keyboards',
  switch: 'switches',
  keycap: 'keycaps'
};

export default function ArticleRouter() {
  const { slug } = useParams();
  const article = articles.find((a) => a.link === `/articles/${slug}`);
  if (!article) return <Navigate to="/in-progress" replace />;
  const folder = typeToFolder[article.type] || '';
  try {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    const mod = require(`../articles/${folder}/${slug}.js`);
    const Component = mod && mod.__esModule ? mod.default : mod;
    if (typeof Component !== 'function') return <Navigate to="/in-progress" replace />;
    return (
      <div className="flex flex-col min-h-screen justify-between">
        <div className="flex-1">
          <Component />
        </div>
      </div>
    );
  } catch (e) {
    return <Navigate to="/in-progress" replace />;
  }
}